import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import device from 'vue-device-detector-js'
import vuetify from './plugins/vuetify'
//import axios from 'axios'
import VueAxios from 'vue-axios'
// import LoadScript from 'vue-plugin-load-script'



//Se permiten las credenciales
axios.defaults.withCredentials = true
axios.defaults.headers['Content-Type'] = 'aplication/json';
//axios.defaults.headers['Content-Type'] ='multipart/form-data';
//axios.defaults.headers['Authorization']=$store.get;
//axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')

/* if (localStorage.getItem('token')) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
} */

import axios from "./middlewares/index"
Vue.prototype.$http = axios

// import LoadScript from 'vue-plugin-load-script'
// Vue.use(LoadScript)
// Vue.loadScript("https://challenges.cloudflare.com/turnstile/v0/api.js")
Vue.use(device)
Vue.use(require('vue-moment'));

// Set document title based on environment
const env = process.env.VUE_APP_ENV || process.env.NODE_ENV;
if (env && env.toLowerCase() !== 'production') {
  document.title = `[${env.toUpperCase()}] - PORTAL WEB - CAJAPSIBA `;
} else {
  document.title = 'PORTAL WEB - CAJAPSIBA';
}
if (navigator.serviceWorker) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
Vue.config.productionTip = false
new Vue({
  router,
  store,
  vuetify,

  render: h => h(App)
}).$mount('#app')
